exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-price-tooltip{width:200px;word-break:break-all;word-wrap:break-word;display:block}.bottom-price-toggle{transform:scale(0.7)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/bottom-line/bottomPrice.scss
// module id = 5892
// module chunks = 0